
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import InvoiceDetailModal from './components/InvoiceDetailModal.vue';
import moment from 'moment';
import PlatPurchaseOrderDetailModal from './components/PlatPurchaseOrderDetailModal.vue';
import SalesOrderDetailModal from './components/SalesOrderDetailModal.vue';

@Component({
  components: {
    InvoiceDetailModal,
    PlatPurchaseOrderDetailModal,
    SalesOrderDetailModal,
  },
})
export default class InvoiceManagement extends Vue {
  activeKey: any = '0';

  data: any[] = [];

  @Ref('invoiceDetailModal')
  invoiceDetailModal!: InvoiceDetailModal;

  @Ref('platPurchaseOrderDetailModal')
  platPurchaseOrderDetailModal!: PlatPurchaseOrderDetailModal;

  @Ref('salesOrderDetailModal')
  salesOrderDetailModal!: SalesOrderDetailModal;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  filterForm: any = {
    start_time: undefined,
    end_time: undefined,
    invoiceStatus: undefined,
  };

  invoiceStatusOptions = [
    { label: '未开票', value: 0 },
    { label: '开票中', value: 1 },
    { label: '已开票', value: 2 },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  // 不同 TAB 表头不同：0（高德——大有）、2（供应商——高德）共用一套；1（大有——经销商）单独一套
  get columns(): any[] {
    if (this.activeKey === '1') {
      return [
        { title: '订单编号', dataIndex: 'order_no', align: 'center' },
        {
          title: '开票方',
          dataIndex: 'invoice_issuer',
          align: 'center',
        },
        {
          title: '收款方',
          dataIndex: 'ticket_seller',
          align: 'center',
        },
        {
          title: '不含税金额',
          dataIndex: 'amount_excluding_tax',
          align: 'center',
        },
        {
          title: '税额',
          dataIndex: 'tax_amount',
          align: 'center',
          scopedSlots: { customRender: 'taxAmount' },
        },
        {
          title: '价税合计',
          dataIndex: 'amount',
          align: 'center',
          scopedSlots: { customRender: 'totalWithTax' },
        },
        { title: '开票日期', dataIndex: 'upload_date', align: 'center' },
        // { title: '状态', dataIndex: 'status', align: 'center' },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ];
    }
    return [
      { title: '请款批次', dataIndex: 'batch_no', align: 'center' },
      { title: '关联PO', dataIndex: 'po', align: 'center' },
      {
        title: '开票方',
        dataIndex: 'invoice_issuer',
        align: 'center',
      },
      {
        title: '收款方',
        dataIndex: 'ticket_seller',
        align: 'center',
      },
      {
        title: '不含税金额',
        dataIndex: 'amount_excluding_tax',
        align: 'center',
      },
      { title: '税额', dataIndex: 'tax_amount', align: 'center' },
      { title: '价税合计', dataIndex: 'plat_amount', align: 'center' },
      { title: '开票日期', dataIndex: 'upload_date', align: 'center' },
      // { title: '状态', dataIndex: 'status', align: 'center' },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        fixed: 'right',
        width: 120,
        scopedSlots: { customRender: 'action' },
      },
    ];
  }

  @Watch('$route')
  async handleSearch() {
    const { activeKey, start_time, end_time, page, pageSize } =
      this.$route.query;
    this.activeKey = activeKey || '0';
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      activeKey: activeKey || '0',
      category: +this.activeKey + 1,
    };
    if (start_time && end_time) {
      params.start_time = start_time;
      params.end_time = end_time;
    }
    this.getList(params);
  }

  tabChange(key: string) {
    this.data = [];
    this.activeKey = key;
    this.getQueryParams();
  }

  mounted() {
    this.handleSearch();
  }

  async getList(params: any) {
    let res: any = '';
    if (params.activeKey === '1') {
      res = await this.supplyService.getDistributorInvoiceList(
        params,
        this.$el,
      );
    } else {
      res = await this.supplyService.getInvoiceList(params, this.$el);
    }
    this.data = res.list;
    this.pagination.total = res.total;
    this.pagination.current = res.page;
  }

  formatDate(date: any) {
    return date ? moment(date).format('YYYY-MM-DD') : '';
  }

  onChangeOrderDate(dates: any) {
    this.filterForm.start_time = this.formatDate(dates && dates[0]);
    this.filterForm.end_time = this.formatDate(dates && dates[1]);
  }

  search() {
    this.pagination.current = 1;
    this.getQueryParams();
  }

  resetQuery() {
    this.filterForm = {
      start_time: '',
      end_time: '',
      invoiceStatus: undefined,
    };
    this.getQueryParams();
  }

  // 查看发票：详情与图片在弹窗内拉取，TAB 决定走哪个详情接口
  viewDetail(record: any) {
    this.invoiceDetailModal.open(record, this.activeKey);
  }

  viewOrder(record: any) {
    console.log(record);
    if (this.activeKey === '1') {
      this.salesOrderDetailModal.open(record);
    } else {
      this.platPurchaseOrderDetailModal.open(record.batch_no);
    }
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  getQueryParams() {
    const { start_time, end_time } = this.filterForm;
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current || 1,
      pageSize: pageSize || 10,
      activeKey: this.activeKey,
    };
    if (start_time && end_time) {
      query.start_time = start_time;
      query.end_time = end_time;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }
}
